export enum PlatformTypeName {
  Standard = 'Platform',
  Platform_Plus = 'Platform+',
}
